import { useContext } from 'react'
import { RemoteAssistanceContext } from 'context/remoteAssistance'

const useRemoteAssistance = () => {
  return useContext(RemoteAssistanceContext)
}

export default useRemoteAssistance
